import { useQuery } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";
import { useNavigate } from "react-router-dom";
import { ROUTE } from "../routes";

type ProfileChecksResponse = {
  results: any[];
};

const fetchProfileChecks = async (authHeader: string, profileId: number) => {
  const url = new URL(`${env.verifyServiceUrl}individual/individual/`);
  url.searchParams.set("mandate__category", "Checks");
  url.searchParams.set("profile", String(profileId));

  const res = await axios.get<ProfileChecksResponse>(url.href, {
    headers: { Authorization: authHeader },
  });

  return res.data;
};

export const useProfileChecks = (profileId?: number) => {
  const { authHeader, hasPermission } = useAuth();
  const navigate = useNavigate();

  return useQuery(
    ["profileChecks", profileId],
    () => fetchProfileChecks(authHeader, Number(profileId)),
    {
      // the endpoint 403s without screening.view, which logs the user out
      enabled: !!profileId && hasPermission("screening.view"),
      keepPreviousData: true,
      retry: true,
      onError: (err: any) => {
        if (err?.request?.status === 500 || err?.request?.status === 503) {
          navigate(ROUTE.SERVER_ERROR);
        }
      },
    }
  );
};
